import { LevelFormat } from '@tiptap-pro/extension-export-docx';
import type { NumberingFormatDefinition } from '@tiptap-pro/extension-export-docx';

// Word's standard multilevel list: decimal / lower-letter / lower-roman repeating
// across the nine depths Word supports. Nine explicit entries rather than three —
// levels cycle by index, so a shorter array would reuse level 0's `%1` template
// and render the outermost counter at depth 3.
const WORD_MULTILEVEL_BASE_STYLES = [LevelFormat.DECIMAL, LevelFormat.LOWER_LETTER, LevelFormat.LOWER_ROMAN] as const;

export const numberingFormats: NumberingFormatDefinition[] = [
  {
    id: 'word-multilevel',
    levels: Array.from({ length: 9 }, (_, depth) => ({
      baseStyle: WORD_MULTILEVEL_BASE_STYLES[depth % WORD_MULTILEVEL_BASE_STYLES.length],
      textTemplate: `%${depth + 1}.`,
    })),
  },
];
